import FormController, { IFormController } from "../FormController";
import QuillEditor, { IQuillEditor, QuillValue } from "./QuillEditor";

interface IFormQuillEditor extends IFormController {
  editor?: IQuillEditor;
  required?: boolean;
}

const isRequired = (value: QuillValue) => {
  if (!value?.plaintext) return "This field is required";
  if (!value?.html) return "Required field";
  if (!value?._html()) return "Required field";
  return true;
};

export const FormQuillEditor = ({ editor, required, rules, ...props }: IFormQuillEditor) => {
  if (!rules) rules = {};
  rules.validate = { ...rules?.validate };
  if (required) rules.validate.isRequired = isRequired;
  return <FormController Children={QuillEditor} childrenProps={editor} rules={rules} {...props} />;
};
